import { Outlet } from 'react-router';
import { useLLMsList } from '@/entities/llm';
import { FormStatusProvider } from '../lib/FormStatusProvider';
import { ScriptList } from './ScriptList';

export function ScriptsPage() {
  const { data: scripts = [], isLoading } = useLLMsList();
  return (
    <FormStatusProvider>
      <div className="w-full h-full p-6 overflow-hidden flex flex-col">
        <div className="mb-4 flex-shrink-0">
          <h1 className="text-heading font-bold text-gray-900 mb-1">LLMs</h1>
          <p className="text-detail text-gray-600">Create and manage LLMs for your AI agents</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 flex-1 min-h-0">
          {/* Left Panel */}
          <ScriptList scripts={scripts} isLoading={isLoading} />

          {/* Right Panel */}
          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </FormStatusProvider>
  );
}